
import { useTranslation } from 'react-i18next';

type AvailabilityStatus = 'available' | 'limited';

interface AvailabilityBadgeProps {
  status?: AvailabilityStatus;
  className?: string;
}

export const AvailabilityBadge = ({
  status = 'available',
  className = ''
}: AvailabilityBadgeProps) => {
  const { t, i18n } = useTranslation();
  const isCJK = i18n.language.startsWith('zh');

  const isAvailable = status === 'available';

  return (
    <div className={`availability-badge ${isAvailable ? 'is-available' : 'is-limited'} ${className}`}>
      <span className="availability-badge-dot" aria-hidden="true" />
      <span className={isCJK ? 'tracking-[0.3em]' : ''}>
        {isAvailable ? t('profile.availableForProjects') : t('profile.limitedAvailability')}
      </span>
      {/* {isAvailable ? (
        <FiCheck className="size-4 text-theme-primary" />
      ) : (
        <FiClock className="size-4 text-theme-primary" />
      )} */}
    </div>
  );
};
